import IMedia from '../../../Player/Interfaces/IMedia';

import MediaType from './Constants/MediaType';

class Media implements IMedia {
    public src: string = '';
    public title: string = '';
    public isEncrypted: boolean = false;
    public posterUrl: string = '';
    public mediaType: MediaType = MediaType.VOD;
    public startTime: number = 0;
    public convivaCustomMetaData: any = {};

    public get isLive(): boolean {
        return this.mediaType === MediaType.LIVE;
    }

    public get isLinear(): boolean {
        return this.mediaType === MediaType.LINEAR;
    }

    public get isVod(): boolean {
        return this.mediaType === MediaType.VOD;
    }

    public get isVodOrLive(): boolean {
        return [MediaType.VOD, MediaType.LIVE].includes(this.mediaType);
    }

    public get isLiveOrLinear(): boolean {
        return [MediaType.LIVE, MediaType.LINEAR].includes(this.mediaType);
    }

    public get hasPoster(): boolean {
        return this.posterUrl !== '';
    }

    public get isLoaded(): boolean {
        return this.src !== '';
    }

    constructor() {
        Object.seal(this);
    }
}

export default Media;